import React, { useEffect, useState } from "react";
import { Phone, PhoneMissed, Loader2, Clock } from "lucide-react";
import api from "@/lib/api";

const ago = (iso) => {
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 1) return "just now";
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} hr ago`;
  const d = Math.round(h / 24);
  return d === 1 ? "yesterday" : `${d} days ago`;
};

const fmtDur = (s) => (s >= 60 ? `${Math.floor(s / 60)}m ${s % 60}s` : `${s}s`);

export const RecentCallsList = ({ onPick, contacts = [] }) => {
  const [calls, setCalls] = useState(null);

  useEffect(() => {
    api.get("/calls").then(({ data }) => setCalls((data || []).slice(0, 30))).catch(() => setCalls([]));
  }, []);

  const nameFor = (num) => contacts.find((c) => (c.number || "").replace(/\D/g, "") === (num || "").replace(/\D/g, ""))?.name;

  if (!calls) return <div className="py-8 text-center text-zinc-400"><Loader2 className="h-5 w-5 animate-spin inline" /></div>;
  if (calls.length === 0) {
    return (
      <div className="py-10 text-center text-sm text-zinc-400" data-testid="recents-empty">
        <Clock className="h-6 w-6 mx-auto mb-2 opacity-50" /> No calls yet — your recent calls will show here.
      </div>
    );
  }

  return (
    <div className="divide-y divide-black/5 -mx-2" data-testid="recents-list">
      {calls.map((c) => {
        const failed = c.status !== "completed";
        const name = nameFor(c.number);
        return (
          <button
            key={c.id}
            onClick={() => onPick(c)}
            data-testid={`recent-row-${c.id}`}
            className="w-full flex items-center gap-3 px-2 py-2.5 text-left hover:bg-zinc-50 active:bg-zinc-100 transition-colors"
          >
            <div className={`h-9 w-9 rounded-full flex items-center justify-center shrink-0 ${failed ? "bg-red-50 text-red-500" : "bg-emerald-50 text-emerald-600"}`}>
              {failed ? <PhoneMissed className="h-4 w-4" /> : <Phone className="h-4 w-4" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm truncate">{name || c.number}</div>
              <div className="text-xs text-zinc-400 truncate">
                {c.flag} {c.country} · {failed ? "Not connected" : `${fmtDur(c.duration_seconds || 0)} · $${(c.cost || 0).toFixed(2)}`}
              </div>
            </div>
            <div className="text-[11px] text-zinc-400 shrink-0">{ago(c.started_at)}</div>
          </button>
        );
      })}
    </div>
  );
};
